import React from "react";
import { Box, Typography, FormControl, Select, MenuItem  } from "@mui/material";

export default function MarketplaceHeader({ activeTab, onTabChange }) {
  return (
    <Box
      className="page-heading-section"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        width: "100%",
        backgroundColor: "rgba(255,255,255,0.8)",
        backdropFilter: "blur(8px)",
        borderRadius: "16px",
        p: 2,
      }}
    >
      <Box className="page-heading">
        <Typography
          component="h2"
          sx={{ fontSize: 48, fontWeight: 600, color: "#121317", lineHeight: 1.2, mb: 0.5 }}
        >
          Explore & Approve Listed Products
        </Typography>
        <Typography sx={{ fontSize: 16, color: "#64748b", fontWeight: 400 }}>
          Check pictures, meta, price & details
        </Typography>
      </Box>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <Select
          value={activeTab}
          onChange={onTabChange}
          displayEmpty
          renderValue={(value) => {
            const labels = ["Products", "Vouchers", "Media", "All"];
            if (value !== null && value !== undefined && typeof value === 'number' && labels[value]) {
              return labels[value];
            }
            return labels[value] || "All";
          }}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            fontWeight: 500,
            color: "#121317",
            "& .MuiSelect-select": {
              padding: "10px 14px",
              color: "#121317",
            },
          }}
        >
          <MenuItem value={0}>Products</MenuItem>
          <MenuItem value={1}>Vouchers</MenuItem>
          <MenuItem value={2}>Media</MenuItem>
          <MenuItem value={3}>All</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
